import React, { createContext, useContext, useReducer, useState } from 'react';
import { Status, useFetchData } from '../../hooks/useFetchData';
import {
  fetchCurrentUserPodcastNetwork,
  NetworkRoleObject,
} from '../../modules/AnchorAPI/account/fetchCurrentUserPodcastNetwork';

type State = NetworkRoleObject & {
  status: Status;
  error: string;
};

const initialState = {
  status: 'loading' as Status,
  networkRole: null,
  networkRoleUserId: null,
  error: '',
  fetchNetworkRole: () => null,
};

type ProviderValue = State & {
  fetchNetworkRole: () => void;
};

const NetworkRoleContext = createContext<ProviderValue>(initialState);

export const useNetworkRole = () => useContext(NetworkRoleContext);
export const NetworkRoleProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const { state: fetchState, fetchData } = useFetchData<{}, NetworkRoleObject>({
    fetchFunction: fetchCurrentUserPodcastNetwork,
    options: { fetchOnFirstRender: false },
  });
  const { json, error, status } = fetchState;
  const value = {
    ...json,
    error,
    status,
    fetchNetworkRole: fetchData,
  };
  return (
    <NetworkRoleContext.Provider value={value}>
      {children}
    </NetworkRoleContext.Provider>
  );
};
